const getYear = () => {
  const currentYear = new Date().getFullYear();
  return currentYear;
};

export default getYear;
